import * as tslib_1 from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Tree, Breadcrumb, Radio, } from "@h3/antd-vue";
let MobileTree = class MobileTree extends Vue {
    constructor() {
        super(...arguments);
        //最新一层的父id，如果再最上层，则id为#
        this.nowId = '#';
        this.routers = [
            {
                path: '#',
                breadcrumbName: '根目录',
            },
        ];
        this.selectIdObj = {
            key: "",
        };
        this.nowData = [];
    }
    //最新一层的数据
    getNowData() {
        // if(this.treeData.length > 0){
        this.nowData = this.listData(this.nowId, this.treeData);
        // }
    }
    /* //最新一层的数据
    get nowData(){
      return this.listData(this.nowId, this.treeData);
    } */
    //进入子结点
    changeClickId(item) {
        console.log(item, "key--------------------------------");
        this.nowId = item.key;
        this.nowData = this.listData(this.nowId, this.treeData);
        const route = {
            path: item.key,
            breadcrumbName: item.title,
        };
        this.routers.push(route);
    }
    routerChange(item, index) {
        if (item.path !== this.nowId) {
            this.nowId = item.path;
            this.nowData = this.listData(this.nowId, this.treeData);
            this.routers.length = index + 1;
        }
        this.selectIdObj = {
            key: "",
        };
    }
    //根据选中的id变成原始的数据对象
    keyToSourceData(key, sourceData) {
        if (!sourceData)
            return {};
        let obj = {};
        for (let i = 0; i < sourceData.length; i++) {
            if (key === sourceData[i].id) {
                obj = sourceData[i];
                break;
            }
            else {
                obj = this.keyToSourceData(key, sourceData[i].data.t__children_);
                if (JSON.stringify(obj) !== '{}')
                    break;
            }
        }
        return obj;
    }
    selectId(key) {
        let obj = this.keyToSourceData(key, this.sourceData);
        this.selectIdObj = obj;
    }
    //确认
    confirm() {
        this.vm.change(this.selectIdObj);
    }
    //清除
    clear() {
        this.nowId = '#';
        this.nowData = this.listData(this.nowId, this.treeData);
    }
    //取消
    cancel() {
        if (this.vm.value.id) {
            this.selectId(this.vm.value.id);
            this.vm.change(this.selectIdObj);
        }
        else {
            this.vm.change({ data: {} });
        }
    }
    //根据选择点击的id找到该子数据返回
    listData(Dataid, treeData) {
        if (treeData.length === 0)
            return [];
        let arr = [];
        if (Dataid === '#') {
            arr = treeData.map((item) => {
                return item;
            });
        }
        else {
            for (let i = 0; i < treeData.length; i++) {
                if (treeData[i].key === Dataid) {
                    arr = treeData[i].children;
                    break;
                }
                else {
                    arr = this.listData(Dataid, treeData[i].children);
                    if (arr.length !== 0)
                        break;
                }
            }
        }
        arr.forEach((item) => {
            item.checked = false;
        });
        console.log(arr, "------------------ARR");
        return arr;
    }
};
tslib_1.__decorate([
    Prop()
], MobileTree.prototype, "sourceData", void 0);
tslib_1.__decorate([
    Prop()
], MobileTree.prototype, "treeData", void 0);
tslib_1.__decorate([
    Prop()
], MobileTree.prototype, "vm", void 0);
tslib_1.__decorate([
    Watch('treeData')
], MobileTree.prototype, "getNowData", null);
MobileTree = tslib_1.__decorate([
    Component({
        name: "mobile-tree",
        components: {
            ATree: Tree,
            ABreadcrumb: Breadcrumb,
            ABreadcrumbItem: Breadcrumb.Item,
            ARadio: Radio,
            ARadioGroup: Radio.Group,
        }
    })
], MobileTree);
export default MobileTree;
